import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-racing.svg";
import * as styles from "./Icon.module.scss";

type RacingProps = React.SVGProps<SVGSVGElement>;

export const Racing = ({ className, ...props }: RacingProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
